import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../../hooks/useTranslations";
import AdminScrewFamilies from "./AdminScrewFamilies";
import AdminScrews from "./AdminScrews";

const AdminScrewsTabs: FC = () => {
  const i18n = useI18n();

  return (
    <Tabs.SubTab>
      <Tabs
        urlParameter="screws_tab"
        tabs={[
          { title: i18n.translation.deckDesignerModule.screws.plural },
          { title: i18n.translation.deckDesignerModule.screwFamilies.plural },
        ]}
        contents={[<AdminScrews />, <AdminScrewFamilies />]}
      />
    </Tabs.SubTab>
  );
};

export default AdminScrewsTabs;
